// import axios from "axios";
import moment from "moment";
import Config from "../config/Config";
import BusinessFareEstimateParametersInterface from "../interfaces/BusinessFareEstimateParametersInterface";
// import BusinessFareInterface from "../interfaces/BusinessFareInterface";
import BusinessOrderParametersInterface from "../interfaces/BusinessOrderParametersInterface";
import API_PUBLIC from "./apiPublic";
import authHeader from "./auth-header";
import authHeaderV2 from "./auth-header-v2";

const API_PUBLIC_URL = Config.BASE_URL_API_PUBLIC;
const API_PUBLIC_URL_V2 = Config.BASE_URL_API_PUBLIC_V2;
const API_PUBLIC_URL_V3 = Config.BASE_URL_API_PUBLIC_V3;

const functionsApiPublic = {
  createBusinessFare(
    businessFareEstimateParameters: BusinessFareEstimateParametersInterface
  ) {
    // return axios.post(API_PUBLIC_URL + `/fare/business/create`,
    // businessFareEstimateParameters,
    // {
    // 	headers: authHeader()
    // });
    return API_PUBLIC.post(
      API_PUBLIC_URL + `/fare/business/create`,
      businessFareEstimateParameters,
      {
        headers: authHeader(),
      }
    );
  },

  createBusinessOrder(
    businessOrderParameters: BusinessOrderParametersInterface
  ) {
    return API_PUBLIC.post(
      `${API_PUBLIC_URL}/order/create`,
      businessOrderParameters,
      {
        headers: authHeader(),
      }
    );
  },

  createBusinessOrderByCoverageArea(
    businessOrderParameters: BusinessOrderParametersInterface
  ) {
    return API_PUBLIC.post(
      `${API_PUBLIC_URL_V2}/v1/order/create`,
      businessOrderParameters,
      {
        headers: authHeaderV2(),
      }
    );
  },

  createBusinessOrderByCoverageAreaV3(
    businessOrderParameters: BusinessOrderParametersInterface
  ) {
    const { directDelivery, deliveryManId, ...data } = businessOrderParameters;

    if (directDelivery) {
      return API_PUBLIC.post(
        `${API_PUBLIC_URL_V3}/order/create-with-delivery`,
        businessOrderParameters,
        {
          headers: authHeaderV2(),
        }
      );
    }

    return API_PUBLIC.post(`${API_PUBLIC_URL_V3}/order/create`, data, {
      headers: authHeaderV2(),
    });
  },

  getFavorities() {
    return API_PUBLIC.get(`${API_PUBLIC_URL_V3}/user-business/favorities`, {
      headers: authHeaderV2(),
    });
  },

  fetchReportsData(
    startDate: Date = new Date(),
    endDate: Date = new Date(),
    offset: number = 0
  ) {
    return API_PUBLIC.get(
      `
			user/reports
			?offset=${offset}
			&startDate=${moment(startDate).format("YYYY-MM-DD")}
			&endDate=${moment(endDate).format("YYYY-MM-DD")}
		`,
      {
        headers: authHeader(),
      }
    );
  },
};

export default functionsApiPublic;
